/**
 * Theme switcher utility
 * Using data-theme attribute for theme switching
 */

export const THEMES = {
  WHITE: 'white',
  SJOGRONN: 'sjogronn',
  HAVSKODDA: 'havskodda',
  MORGENDIS: 'morgendis',
};

// Set theme by updating the data-theme attribute on the body
export const setTheme = (theme) => {
  // If the provided theme is already applied, don't re-apply it
  if (document.body.getAttribute('data-theme') === theme) {
    return;
  }
  
  // Only apply recognized themes or valid custom themes
  if (Object.values(THEMES).includes(theme) || typeof theme === 'string') {
    document.body.setAttribute('data-theme', theme);
    
    // Dispatch an event that theme has changed
    document.dispatchEvent(new CustomEvent('themeChanged', {
      detail: { theme, previousTheme: document.body.getAttribute('data-theme') }
    }));
  }
};

// Get the current theme
export const getTheme = () => {
  return document.body.getAttribute('data-theme') || THEMES.WHITE;
};

// Initialize theme with default or system preference
export const initTheme = () => {
  // If system prefers dark mode and no explicit theme set, use dark theme
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    if (!document.body.hasAttribute('data-theme')) {
      setTheme(THEMES.GREEN);
    }
  }
  
  // Listen for theme change events from UI components
  document.addEventListener('themeChange', (event) => {
    if (event.detail && event.detail.theme) {
      setTheme(event.detail.theme);
    }
  });
  
  // Optional: Listen for system theme changes
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    // Only apply if there's no explicit theme set
    if (!document.body.hasAttribute('data-theme')) {
      setTheme(e.matches ? THEMES.GREEN : THEMES.WHITE);
    }
  });
};